'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Api = require('../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _LoginStore = require('./LoginStore');

var _LoginStore2 = _interopRequireDefault(_LoginStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],

    // fetchParseConfig() {
    //     Api.fetchParseConfig();
    // },

    loadFbLoginApi: function loadFbLoginApi() {
        _Api2.default.loadFbLoginApi();
    },
    setHistoryRouterObject: function setHistoryRouterObject(history) {
        this._history = history;
    },
    getHistoryRouterObject: function getHistoryRouterObject() {
        return this._history;
    },
    setLocationObjectID: function setLocationObjectID(locId) {
        this._locId = locId;
    },
    getLocationObjectID: function getLocationObjectID() {
        return this._locId;
    },
    getLiveItemDetailsMap: function getLiveItemDetailsMap() {
        if (this.data) {
            return this.data.liveItemIdItemDetailsMap;
        }
    },
    getMainScreenDataSet: function getMainScreenDataSet() {
        if (this.data) {
            return this.data;
        }
        return null;
    },
    getParentGroup: function getParentGroup(parentGroup) {
        if (!parentGroup) {
            return;
        }

        var parentGroupId = parentGroup.objectId;

        if (this.data && this.data.parentGroupsMap) {
            return this.data.parentGroupsMap[parentGroupId].groupDetail;
        }

        return null;
    },
    getGroupOnlineOrderingHours: function getGroupOnlineOrderingHours(groupDetail, orderTypeNew) {
        // get the order type here

        switch (orderTypeNew) {
            case 'PickUp':
                // code block
                return groupDetail.pickUpHours ? groupDetail.pickUpHours : groupDetail.openHours;
                // return "pickup";
                break;
            case 'Delivery':
                // code block
                return groupDetail.deliveryHours ? groupDetail.deliveryHours : groupDetail.openHours;
                // return "delivery";
                break;
            default:
                // code block
                return groupDetail.openHours;
        }
    },
    getGroupOpenHours: function getGroupOpenHours(groupDetail, orderType) {

        if (groupDetail) {

            var groupOpenHours = this.getGroupOnlineOrderingHours(groupDetail, orderType);

            if (groupOpenHours && groupOpenHours != null) {

                return groupOpenHours;
            } else {
                var parentGroup = this.getParentGroup(groupDetail.parentGroup);

                if (parentGroup) {
                    var parentGroupOpenHours = this.getGroupOnlineOrderingHours(parentGroup, orderType);
                    if (parentGroupOpenHours && parentGroupOpenHours != null) {

                        return parentGroupOpenHours;
                    }
                }
            }
        }

        return null;
    },
    getAllData: function getAllData(activeLocationIndex, activeLocationId, afterSuccess) {
        var _this = this;

        return _Api2.default.getAllDataViaRest(activeLocationIndex, activeLocationId).then(function (data) {
            data["groupHierarchy"] = _this.generateGroupHierarchy(data);
            return data;
        }).then(function (data) {
            data["menuHierarchy"] = _this.generateMenuHierarchy(data.groupHierarchy);
            _this.data = data;
            return data;
        }).then(function (data) {
            _this.triggerChange();

            if (afterSuccess != null && typeof afterSuccess === "function") {
                // call the function here
                afterSuccess();
            }
        });
    },
    generateMenuHierarchy: function generateMenuHierarchy(groupHierarchy) {
        var menuArray = [];
        groupHierarchy.forEach(function (groupObject) {

            // check hideAfterHours is set or not
            // check current time exist in the group open hours
            var isGroupVisible = Utils.isGroupShownAfterHours(groupObject.groupDetail);

            if (isGroupVisible != false) {
                var group = { groupName: groupObject.groupDetail.groupName, subGroups: null };
                if (groupObject.subGroups && groupObject.subGroups.length > 0) {
                    var subGroupArray = [];
                    groupObject.subGroups.map(function (subGroup) {

                        // check hideAfterHours is set or not
                        // check current time exist in the group open hours
                        var isSubGroupVisible = Utils.isGroupShownAfterHours(subGroup.groupDetail);

                        if (isSubGroupVisible != false) {
                            subGroupArray.push(subGroup.groupDetail.groupName);
                        }
                    });

                    group["subGroups"] = subGroupArray;
                }
                menuArray = menuArray.concat(group);
            }
        });
        return menuArray;
    },
    generateGroupHierarchy: function generateGroupHierarchy(data) {
        var groupDetails = data.GroupDetails;
        var itemDetails = data.ItemDetails;
        var liveItemDetails = itemDetails.filter(function (itemDetail) {
            return itemDetail.live;
        });
        var businessDetail = data.BusinessDetail;
        var orderedGroupIds = [];
        var sortedGroupedItemDetails = {};
        var groupHierarchy = [];

        if (businessDetail) {

            // const groupIds = businessDetail.groupIds;
            // Groups Reorder functionality fixed:
            //     If multiple location enable then choose the groups Order from location table otherwise it choose in business table.

            var groupIds = [];

            if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == false) {
                groupIds = data.LocationDetail.groupIds;
            } else {
                groupIds = businessDetail.groupIds;
            }

            var liveItemIdItemDetailsMap = {};
            liveItemDetails.forEach(function (itemDetail) {
                liveItemIdItemDetailsMap[itemDetail.objectId] = itemDetail;
            });

            data.liveItemIdItemDetailsMap = liveItemIdItemDetailsMap;

            var subGroupIdGroupDetailsMap = {};
            groupDetails.filter(function (groupDetail) {
                return groupDetail.parentGroup || !groupDetail.groupType && !groupDetail.parentGroup;
            }).forEach(function (groupDetail) {
                return subGroupIdGroupDetailsMap[groupDetail.objectId] = groupDetail;
            });

            var orderedMerge = function orderedMerge() {
                var prevOrderedArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var newArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

                var newArrayData = prevOrderedArray.length > 0 ? prevOrderedArray.concat(newArray.filter(function (i) {
                    return prevOrderedArray.indexOf(i) == -1;
                })) : newArray;

                // return the unique array data
                var filteredUniqueArray = newArrayData.filter(function (item, pos) {
                    return newArrayData.indexOf(item) == pos;
                });

                return filteredUniqueArray;
            };

            var generateSortedItemDetails = function generateSortedItemDetails(itemDetailsMap, groupDetail) {

                var filteredItemIds = Object.keys(itemDetailsMap).filter(function (itemId) {
                    var itemDetail = itemDetailsMap[itemId];
                    return itemDetail && itemDetail.groupDetailPointer.objectId == groupDetail.objectId;
                });

                return orderedMerge(groupDetail.itemIds, filteredItemIds).map(function (itemId) {
                    return itemDetailsMap[itemId];
                }).filter(function (x) {
                    return x;
                });
            };

            var generateSortedGroupDetails = function generateSortedGroupDetails(groupDetailsMap, groupDetail) {

                var filteredGroupIds = Object.keys(groupDetailsMap).filter(function (groupId) {
                    var childGroup = groupDetailsMap[groupId];
                    return childGroup && childGroup.parentGroup && childGroup.parentGroup.objectId == groupDetail.objectId;
                });

                return orderedMerge(groupDetail.childGroupIds, filteredGroupIds).map(function (groupId) {
                    return {
                        groupType: 'SIMPLE',
                        groupDetail: groupDetailsMap[groupId],
                        sortedItemDetails: generateSortedItemDetails(liveItemIdItemDetailsMap, groupDetailsMap[groupId]),
                        parentGroupId: groupDetail
                    };
                }).filter(function (subGroupObj) {
                    return !subGroupObj.groupDetail.hide;
                });
            };

            var parentGroups = {};
            groupDetails.filter(function (groupDetail) {
                return groupDetail.groupType === 'MENU' && !groupDetail.hide;
            }).forEach(function (groupDetail) {
                parentGroups[groupDetail.objectId] = {
                    groupType: 'MENU',
                    groupDetail: groupDetail,
                    subGroups: generateSortedGroupDetails(subGroupIdGroupDetailsMap, groupDetail),
                    parentGroupId: null
                };
            });

            data.parentGroupsMap = parentGroups;

            Object.keys(subGroupIdGroupDetailsMap).forEach(function (subGroupId) {
                var subGroupDetail = subGroupIdGroupDetailsMap[subGroupId];
                var subGroupObj = {
                    groupType: 'SIMPLE',
                    groupDetail: subGroupDetail,
                    sortedItemDetails: generateSortedItemDetails(liveItemIdItemDetailsMap, subGroupDetail),
                    parentGroupId: null
                };

                if (!subGroupDetail.parentGroup && !subGroupDetail.hide) {
                    parentGroups[subGroupDetail.objectId] = subGroupObj;
                }
            });
            groupHierarchy = orderedMerge(groupIds, Object.keys(parentGroups)).map(function (groupId) {
                return parentGroups[groupId];
            }).filter(function (x) {
                return x;
            });
        }

        return groupHierarchy;
    },


    // refreshLocation(locationDetail) {
    //     this.data.LocationDetail = locationDetail;
    //     this.triggerChange();
    // },

    getBusinessDetail: function getBusinessDetail() {
        if (this.data) {
            return this.data.BusinessDetail;
        }
        return null;
    },
    getStripePublishableKey: function getStripePublishableKey() {

        var businessDetail = this.getBusinessDetail();

        if (!Utils.isEmptyObj(businessDetail) && !businessDetail.isLive || this.isTestUser()) {
            // return the test publishable key
            return PARSE_DEV_SP_KEY;
        } else {
            // return the live publishable key
            return PARSE_PROD_SP_KEY;
        }
    },
    isTestUser: function isTestUser() {

        var currentUser = _parse2.default.User.current();

        if (currentUser) {

            if (currentUser.isTest) {
                return true;
            }
        }

        return false;
    },
    getActiveLocation: function getActiveLocation() {

        if (this.data && this.data.LocationDetail) {
            return this.data.LocationDetail;
        }
        return null;
    },


    // check Location is enabled only for DineIn
    isLocationForDineInOnly: function isLocationForDineInOnly() {
        var isDineIn = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.dineInOnly && locationConfig.dineInOnly == true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return isDineIn;
    },
    isDineInEnabled: function isDineInEnabled() {
        var isDineIn = false;
        var activeLocation = this.getActiveLocation();
        if (!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(activeLocation.dineIn)) {

            var dineInObj = activeLocation.dineIn;
            if (dineInObj.enabled == true) {
                return true;
            } else {
                return false;
            }
        }
        return isDineIn;
    },


    // "hideDeliveryIcon": false,
    // "hidePickupIcon": false,
    // "hideDineInIcon": false

    getOrderPlacedConfig: function getOrderPlacedConfig(orderType) {
        var hideOrderPlacedIcon = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var orderPlacedConfig = activeLocation.orderPlacedConfig;

            if (orderPlacedConfig) {

                if (orderType == "DineIn" && orderPlacedConfig.hideDineInIcon) {
                    return true;
                } else if (orderType == "Delivery" && orderPlacedConfig.hideDeliveryIcon) {
                    return true;
                } else if (orderType == "PickUp" && orderPlacedConfig.hidePickupIcon) {
                    return true;
                } else {
                    return hideOrderPlacedIcon;
                }
            } else {
                return hideOrderPlacedIcon;
            }
        }
        return hideOrderPlacedIcon;
    },


    // check the change location button is hidden or visible
    hideChangeLocationBtn: function hideChangeLocationBtn() {
        var isChangeLocation = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {

            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.hideChangeLocation && locationConfig.hideChangeLocation == true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return isChangeLocation;
    },


    // check the change location button is hidden or visible
    isLogoSameForAllLocation: function isLogoSameForAllLocation() {
        var defaultLogo = true;

        var businessDetail = this.getBusinessDetail();

        if (businessDetail != null) {

            var bizConfig = businessDetail.bizConfig;

            if (bizConfig && bizConfig != null) {
                var isLogoSameForAllLocation = bizConfig.isLogoSameForAllLocation;

                if (typeof isLogoSameForAllLocation !== 'undefined') {
                    // the variable is defined
                    return isLogoSameForAllLocation;
                } else {
                    return defaultLogo;
                }
            }
        }
        return defaultLogo;
    },

    // check the menu type row is configured or not
    isMenuTypeRow: function isMenuTypeRow() {
        var menuTypeRow = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {

            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.menuType && locationConfig.menuType == "ROW") {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return menuTypeRow;
    },


    // check Pickup Order is disabled or not
    isPickUpOrderDisabled: function isPickUpOrderDisabled() {
        var disablePickupOrder = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.disablePickUp && locationConfig.disablePickUp == true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return disablePickupOrder;
    },


    // check Location Utensils and Napkins is enabled or not
    isLocUtensilsAndNapkinsEnabled: function isLocUtensilsAndNapkinsEnabled() {
        var enableUtensilsAndNapkins = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.enableUtensilsAndNapkins && locationConfig.enableUtensilsAndNapkins == true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return enableUtensilsAndNapkins;
    },


    // check Location Utensils and Napkins is enabled or not
    isGuestUserIsTest: function isGuestUserIsTest() {
        var isTest = false;

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.hasOwnProperty("guestUserIsTest") && locationConfig.guestUserIsTest == true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return isTest;
    },


    // check Location Utensils and Napkins is enabled or not
    getLocationTimeZone: function getLocationTimeZone() {

        var activeLocation = this.getActiveLocation();

        if (activeLocation != null) {
            var locationTimeZone = activeLocation.timeZone;

            return locationTimeZone;
        }
        return null;
    },

    /*
    * Get date time based on the location
    * */
    getCurrentDateTime: function getCurrentDateTime(defaultTimeZone) {

        var timeZone = "";
        if (!Utils.isEmpty(defaultTimeZone) && defaultTimeZone != null) {
            timeZone = defaultTimeZone;
        } else {
            // get selected location timezone
            timeZone = this.getLocationTimeZone();
        }
        var currentDateTime = new Date();

        if (!Utils.isEmpty(timeZone)) {
            // change local date time based on the location timezone
            var locationTime = Utils.changeTimezone(currentDateTime, timeZone);
            // return the location date time
            return locationTime;
        } else {
            // return the location date time
            return currentDateTime;
        }
    },
    triggerChange: function triggerChange() {
        this.trigger('change', this.data);
    }
});
exports.default = MainStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/MainStore.jsx
// module id = 231
// module chunks = 0